<!-- TEMPLATE -->
<template>
  <div class="dean-section-title">
    <span :class="deanSectionTitleClass">
      <span v-if="mobileButton || sidemenuButton" class="dean-section-title-sidemenu-button">
        <slot name="sidemenu-button"></slot>
        <slot name="mobile-button"></slot>
      </span>
      <slot name="title"></slot>
      <span class="dean-section-title-buttons">
        <slot></slot>
      </span>
    </span>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

// COMPONENTS
@Component({ })

export default class deanSectionTitle extends Vue {
  //PROPS
  @Prop() theme?: string;
  @Prop({ default: false }) secondary?: boolean;
  @Prop({ default: false }) sidebar?: boolean;
  @Prop({ default: false }) content?: boolean;
  @Prop({ default: false }) result?: boolean;
  @Prop({ default: false }) mobileButton?: boolean;
  @Prop({ default: false }) sidemenuButton?: boolean;

  // COMPUTED
  get deanSectionTitleClass() {
  let value = 'dean-section-title-bar'
  if (this.sidebar)  value += ` dean-section-title-bar-sidebar`
  if (this.secondary)  value += ` dean-section-title-bar-secondary`
  if (this.content)  value += ` dean-section-title-bar-content`
  if (this.result)  value += ` dean-section-title-bar-result`
  if (this.theme === 'themed')  value += ` dean-section-title-bar-sidebar`
  if (this.theme) {
    value += ` dean-section-title-bar-${this.theme}`
  }
  return value
}
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>

// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

// DEAN SECTION TITLE
.dean-section-title {
    display: block;
    padding: 10px;

    .dean-section-title-bar {
      display: block;
      padding: 10px;
      height: 50px;
      text-align: left;
      text-transform: uppercase;
      font-style: italic;
      font-weight: 500;
      font-size: $font-heading-small;
      color: black;
      @include border-radius(10px);
    }
    .dean-section-title-bar-sidebar {
      background: var(--color-light-shade-3, $color-light-shade-3);
      border: 1px solid var(--color-light, $color-light);
    }
    .dean-section-title-bar-secondary {
      border: 1px solid var(--color-light, $color-light);
    }
    .dean-section-title-bar-content {
      color: white;
      background: var(--color-primary, $color-primary);
      border: 1px solid var(--color-primary, $color-primary);
    }
    .dean-section-title-bar-result {
      color: white;
      background: var(--color-secondary, $color-secondary);
      border: 1px solid var(--color-secondary, $color-secondary);
    }
    .dean-section-title-sidemenu-button {
      padding-right: 10px;
      float: left;
    }
    .dean-section-title-buttons {
      float: right;
    }
}

// THEMED
/*
.themed {
  // DEAN SECTION TITLE
  .dean-section-title {
    // THEMING MIXIN
    // @include themify($themes) {
      .dean-section-title-bar { color: white; }
      .dean-section-title-bar-sidebar {
        background: none;
        border: 1px solid var(--color-light, $color-light);
      }
    // }
  }
}
*/
</style>
